export const FieldValue = ({
  value,
  emptyText = 'ø empty',
  format,
}: {
  value?: string | number | null;
  emptyText?: string;
  format?: (value: string) => string;
}) => {
  if (value === undefined || value === null || value === '') {
    return <span style={{ color: '#B3B3B3' }}>{emptyText}</span>;
  }

  const displayValue = String(value);

  return <span>{format ? format(displayValue) : displayValue}</span>;
};
